import template from './home-root.html';

import HomeButton from '../home-button/home-button';
import Kiwi from '../kiwi/kiwi-service';
import Loader from '../loader/loader';
import HeaderRoot from '../header/header-root';

export default {
	name: 'HomeRoot',
	template,
	components: {HomeButton, Loader, HeaderRoot},
	created () {
		// konfigurace
		const {config, params, images} = this.$root;
		// lokalni konfigurace
		this.loadingTime = config.loadingTime;
		this.videoThumbnailLength = config.videoThumbnailLength;
		this.targetName = config.targetName;
		this.images = images;
		this.logo = params.logo;
		this.tv = (params.tv === 'true');
		this.buttons = this.getButtons();
		// vytvoreni prazdneho kiwi targetu - pro prehrani videa
		Kiwi.createTarget(this.targetName);
	},
	mounted () {
		// Loading time 2s
		setTimeout(() => {
			this.isLoading = false;
			// After loaded wait 1s then auto play
			setTimeout(() => {
				this.refreshVideo();
			}, 1000);
		}, this.loadingTime * 1000);
	},
	destroyed () {
		clearInterval(this.loopTimer);
	},
	data () {
		return {
			images: null,
			logo: '',
			tv: false,
			loadingTime: 1,
			buttons: null,
			loopTimer: null,
			videoThumbnailLength: 5,
			loopVideoIdx: 0,
			forceVideoIdx: null,
			isLoading: true
		};
	},
	methods: {
		pauseVideo (idx) {
			if (typeof idx === 'undefined' || idx === null || !this.$refs['button.id'][idx].isPlaying) {
				return;
			}
			this.$refs['button.id'][idx].pause();
			this.$refs['button.id'][idx].isPlaying = false;
		},
		playVideo (idx) {
			if (typeof idx === 'undefined' || idx === null || this.$refs['button.id'][idx].isPlaying) {
				return;
			}
			this.$refs['button.id'][idx].play()
			.then(() => {
				// console.log('The play() Promise success!');
				this.$refs['button.id'][idx].isPlaying = true;
			})
			.catch(() => {
				// console.log('The play() Promise rejected!');
				this.$refs['button.id'][idx].isPlaying = false;
			});
		},
		onVideoPlayForce (id) {
			// Stop video loop
			clearTimeout(this.loopTimer);
			// Stop video from loop
			this.pauseVideo(this.loopVideoIdx);
			// Stop force video, if play
			this.pauseVideo(this.forceVideoIdx);
			// Play clicked video
			this.forceVideoIdx = id;
			this.playVideo(this.forceVideoIdx);
		},
		refreshVideo () {
			this.playVideo(this.loopVideoIdx);
			// 0 full length
			if (this.videoThumbnailLength > 0) {
				this.loopTimer = setTimeout(() => {
					this.pauseVideo(this.loopVideoIdx);
					this.nextVideoIdx();
					this.refreshVideo();
				}, this.videoThumbnailLength * 1000);
			}
		},
		getVideoElemByIdx (idx) {
			let index = idx;
			if (index >= this.$refs['button.id'].length || index < 0) {
				index = 0;
			}
			return this.$refs['button.id'][index];
		},
		getButtonByIdx (idx) {
			return this.buttons[idx];
		},
		nextVideoIdx () {
			this.loopVideoIdx = this.nextIdx(this.loopVideoIdx, this.buttons.length - 1);
			const videoButton = this.getButtonByIdx(this.loopVideoIdx);
			if (videoButton.isDisabled || videoButton.isTv) {
				this.nextVideoIdx();
			}
		},
		nextIdx (idx, max) {
			let newIdx = idx + 1;
			if (newIdx > max || newIdx < 0) {
				newIdx = 0;
			}
			return newIdx;
		},
		onVideoEnd (id) {
			this.pauseVideo(id);
			this.nextVideoIdx();
			this.refreshVideo();
		},
		getButtons () {
			return [
				{
					id: 0,
					text: 'Filmová ukázka',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/movie1.mp4',
					posterImage: this.images.Movie1,
					textIcon: this.images.MovieIcon,
					isTv: false,
					isDisabled: false
				},
				{
					id: 1,
					text: 'Příroda',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/nature1.mp4',
					posterImage: this.images.Nature1,
					textIcon: this.images.NatureIcon,
					isTv: false,
					isDisabled: false
				},
				{
					id: 2,
					text: 'Sport',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/sport.mp4',
					posterImage: this.images.Sport1,
					textIcon: this.images.SportIcon,
					isTv: false,
					isDisabled: false
				},
				{
					id: 3,
					text: 'Televizní vysílání',
					videoSource: '',
					posterImage: this.images.Dvbt,
					textIcon: this.images.DvbtIcon,
					isTv: this.tv,
					isDisabled: !this.tv
				},
				{
					id: 4,
					text: 'Filmová ukázka',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/movie2.mp4',
					posterImage: this.images.Movie2,
					textIcon: this.images.MovieIcon,
					isTv: false,
					isDisabled: false
				},
				{
					id: 5,
					text: 'Příroda',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/nature2.mp4',
					posterImage: this.images.Nature2,
					textIcon: this.images.NatureIcon,
					isTv: false,
					isDisabled: false
				},
				{
					id: 6,
					text: 'Sport',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/sport2.mp4',
					posterImage: this.images.Sport2,
					textIcon: this.images.SportIcon,
					isTv: false,
					isDisabled: false
				},
				{
					id: 7,
					text: 'Akční nabídka',
					videoSource: 'http://http.office.ki-wi.cz/martin-web/Euronics/smycka.mp4',
					posterImage: this.images.Sale,
					textIcon: this.images.SaleIcon,
					isTv: false,
					isDisabled: false
				}
			];
		}
	}
};



// WEBPACK FOOTER //
// ./src/home/home-root.js